/**
* シェアボタンのコンストラクタ
* @constructor
* @param {selector} el - セレクタ
*/
module.exports = Share = function(el){
  this.element = $(el);
  this.url = location.href;
  this.title = document.title;
  this.type = this.element.attr('data-share-type');
  this.event();
};

/**
* イベント
*/
Share.prototype.event = function(){
  var self = this;
  var share;
  var href = this.element.attr('href');
  switch (self.type){
    case 'facebook':
      share = encodeURIComponent(self.url);
      break;
    case 'twitter':
      share = encodeURIComponent(self.url) + '&text=' + encodeURIComponent(self.title);
      break;
    case 'line':
      share = encodeURIComponent(self.title) + encodeURIComponent(self.url);
      break;
  }
  this.element.attr('href', href + share);
};


//////////////////
// WEBPACK FOOTER
// ./js/_modules/share.js
// module id = 7
// module chunks = 0